/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React from 'react'
import Cross from 'AccountsIcons/cross.svg'
import { getCurrencyByReq } from 'AccountsUtils'

const FareRuleRefundBreakUp = ({ onClose = () => { }, breakupItem = {}, currency }) => {
  const { chargesBreakup: chargesBreakups, refundableAmount, timeline } = breakupItem || {}
  const AMOUNT_REFUNDABLE = 'Amount Refundable'
  return (
    <div className="br0 bbr0 bbl0">

      <div className="flex flex-middle flex-between pt-0012 pb-0012 h-40 pl-0016 pr-0016" style={{ backgroundColor: '#f6f6f8', position: 'fixed', top: '-1px', width: '100%' }}>
        <p className="fs-14 fw-500">Cancel between</p>
        <span onClick={() => onClose()}>
          <Cross fill="#4d4d4d" />
        </span>
      </div>

      <div className="bg-white pl-0016 pt-004 pb-20 pr-0016 ta-l">

        <div className="bb  h-48 flex flex-middle flex-between mb-2 mt-12">
          <p className="fs-14 fw-600 c-black-90">{timeline.startTimeDate} - {timeline.endTimeDate}</p>
        </div>
        {chargesBreakups && chargesBreakups.map((field, index) => {
          const { groupName, chargesBreakup = [] } = field
          return (

            <div>
              <If condition={groupName}>
                <div className="flex flex-between w-210 c-grey-50 pt-1">
                  <div className="fs-3 fw-600 tt-uppercase ">{groupName}</div>
                </div>
              </If>
              <If condition={chargesBreakup && chargesBreakup.length > 0}>
                {
                  chargesBreakup.map(
                    (charge, idx) => {
                      const { totalAmount, name, code, paxWiseBreakup = [] } = charge
                      return (

                        <If condition={totalAmount && name}>
                          <div className="flex flex-between w-210  ">
                            <div className={`${code === 'AMOUNT_PAID' ? 'fs-3' : 'fs-3'}`}>{name}</div>
                            <div className={`${code === 'AMOUNT_PAID' ? 'fs-3' : 'fs-3'}`} style={{ lineHeight: '18px' }}>
                              {getCurrencyByReq(totalAmount, currency)}
                            </div>

                          </div>

                          <If condition={paxWiseBreakup && paxWiseBreakup.length > 0 && code !== 'CLTP_CANCEL_CHARGE' && code !== 'CON_FEE'}>
                            {paxWiseBreakup.map(
                              paxCharge => {
                                const { paxCount, paxType, chargePerPax } = paxCharge
                                return (

                                  <div className="flex flex-between w-210 pl-4 ">
                                    <div className="fs-2" style={{ display: 'list-item' }}>{`${paxType === 'ADT' ? 'Adult ' : paxType === 'CHD' ? 'Child ' : 'Infant '}(${getCurrencyByReq(chargePerPax, currency)}x${paxCount})`}</div>
                                    <div className="fs-2" style={{ lineHeight: '18px' }}>
                                      {getCurrencyByReq(chargePerPax * paxCount, currency)}
                                    </div>
                                  </div>

                                )
                              }
                            )}
                          </If>
                        </If>

                      )
                    }
                  )
                }
              </If>

            </div>

          )
        })
        }
        <div className="flex flex-between w-210  mt-3 pt-2 fw-600" style={{ borderTop: '1px dashed rgb(204, 204, 204)' }}>
          <div className="fs-3">{AMOUNT_REFUNDABLE}</div>
          <div className="fs-3" style={{ lineHeight: '18px' }}>
            {getCurrencyByReq(refundableAmount, currency)}
          </div>
        </div>
      </div>

    </div>
  )
}

export default FareRuleRefundBreakUp
